import Drawer from '@zenbusiness/zui/Drawer';
import { styled } from '@zenbusiness/zui/styles';

const DrawerStyle = ({ theme }) => ({
  zIndex: theme.zIndex.modal + 1,
  '& .MuiPaper-root': {
    borderRadius: '16px 16px 0 0',
    padding: '16px 0',
    boxShadow: '0px 4px 16px 2px rgba(46, 46, 46, 0.15)'
  }
});

export const MobileDrawerStyled = styled(Drawer)(DrawerStyle);
